import { money, fmtDate, fmtTime, fmtDateTime } from "@/lib/format";
import { PrintBrand, ThermalBrand } from "@/components/Brand";

export default function ManifestView({ m, format = "a4" }) {
  const t = m.trip;
  const multi = (t.stops || []).length > 2;
  if (format === "thermal") {
    return (
      <div className="thermal">
        <ThermalBrand title="PASSENGER MANIFEST" />
        <div className="center">{t.origin_city} &gt; {t.destination_city}</div>
        <div className="center">{fmtDate(t.departure)} {fmtTime(t.departure)} · Bus {t.bus_number}</div>
        <div className="center">Driver: {t.driver_name}</div>
        <div className="center">{t.tracker_active ? `Tracker ID: ${t.tracker_id}` : "No tracker installed"}</div>
        <hr />
        {m.passengers.map((p) => (
          <div key={p.ticket_no}>
            <div className="row"><span>{String(p.seat).padStart(2, "0")} {p.name.slice(0, 14)}{multi ? ` ${(p.from_city || "").slice(0, 3)}-${(p.to_city || "").slice(0, 3)}` : ""}</span><span>{p.payment_status === "paid" ? "PAID" : "UNPAID"}</span></div>
            <div className="row" style={{ fontSize: "10px" }}><span>{(p.gender || "-").slice(0, 1).toUpperCase()} · {p.age ? `${p.age}yr` : "-"} · {p.phone}</span></div>
            <div className="row" style={{ fontSize: "10px" }}><span>Kin: {p.kin_name || "-"} {p.kin_phone || ""}</span></div>
          </div>
        ))}
        <hr />
        <div className="row"><span>Passengers</span><span>{m.passengers.length}/{t.capacity}</span></div>
        <div className="row"><span>Revenue</span><span>{money(m.revenue)}</span></div>
        <div className="center">Printed {fmtDateTime(m.generated_at)}</div>
      </div>
    );
  }
  return (
    <div className="a4 text-sm" data-testid="manifest-view">
      <PrintBrand title="Passenger Manifest" />
      <div className="mt-3 flex items-start justify-between border-b border-slate-200 pb-3">
        <div>
          <div className="font-semibold">{t.origin} ({t.origin_city}) → {t.destination} ({t.destination_city})</div>
          {multi && <div className="text-xs text-slate-500" data-testid="manifest-stops">Stops: {t.stops.map((s) => `${s.city} ${fmtTime(s.departure)}`).join(" → ")}</div>}
        </div>
        <div className="text-right text-xs">
          <div><b>Departure:</b> {fmtDate(t.departure)} {fmtTime(t.departure)}</div>
          <div><b>Bus:</b> {t.bus_number} ({t.bus_type}, {t.capacity} seats)</div>
          <div><b>Driver:</b> {t.driver_name} {t.driver_phone}</div>
          <div data-testid="manifest-tracker"><b>Tracker:</b> {t.tracker_active ? t.tracker_id : "No tracker installed"}</div>
          <div><b>Status:</b> {t.status}{t.dispatched_at ? ` at ${fmtDateTime(t.dispatched_at)}` : ""}</div>
        </div>
      </div>
      <table className="mt-3 w-full text-left text-xs">
        <thead><tr className="border-b border-slate-300 bg-slate-50"><th className="p-1.5">Seat</th><th>Passenger</th><th>Gender</th><th>Age</th><th>Next of kin</th>{multi && <th>Journey</th>}<th>Phone</th><th>Ticket no.</th><th>Channel</th><th>Payment</th><th>Insured</th><th>Boarded</th></tr></thead>
        <tbody>
          {m.passengers.map((p) => (
            <tr key={p.ticket_no} className="border-b border-slate-100" data-testid={`manifest-row-${p.seat}`}>
              <td className="p-1.5 font-bold">{p.seat}</td><td>{p.name}</td>
              <td className="capitalize" data-testid={`manifest-gender-${p.ticket_no}`}>{p.gender || "-"}</td>
              <td data-testid={`manifest-age-${p.ticket_no}`}>{p.age || "-"}</td>
              <td data-testid={`manifest-kin-${p.ticket_no}`}>{p.kin_name ? <span>{p.kin_name}<br /><span className="text-slate-500">{p.kin_phone}</span></span> : "-"}</td>
              {multi && <td data-testid={`manifest-journey-${p.ticket_no}`}>{p.from_city} → {p.to_city}</td>}<td>{p.phone}</td><td className="font-mono">{p.ticket_no}</td>
              <td className="capitalize">{p.channel}</td><td>{p.payment_status === "paid" ? "Paid" : "Unpaid"}</td><td>{p.insured ? "Yes" : ""}</td><td>{p.boarded ? "Yes" : ""}</td>
            </tr>
          ))}
          {!m.passengers.length && <tr><td colSpan={multi ? 12 : 11} className="p-4 text-center text-slate-500">No passengers booked</td></tr>}
        </tbody>
      </table>
      <div className="mt-3 flex justify-between font-semibold">
        <span>Passengers: {m.passengers.length} / {t.capacity} (paid {m.paid_count})</span>
        <span>Revenue: {money(m.revenue)}</span>
      </div>
      <div className="mt-10 grid grid-cols-3 gap-6 text-xs">
        <div className="border-t border-slate-400 pt-1">Station master</div>
        <div className="border-t border-slate-400 pt-1">Driver</div>
        <div className="border-t border-slate-400 pt-1">Generated by {m.generated_by}, {fmtDateTime(m.generated_at)}</div>
      </div>
    </div>
  );
}
